/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CalendarOutlined,
  DeleteFilled,
  EditOutlined,
  LoadingOutlined,
  PhoneOutlined,
  PicLeftOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Avatar,
  Button,
  Card,
  Flex,
  Popconfirm,
  Space,
  Tooltip,
  Typography,
} from 'antd'
import React from 'react'
import { useShowMaintenance } from '~/hooks/Maintenance/useShowMaintenance'
import { LoadingIndicator } from '~/pages/Contributor/ShowContributor/styles'
import { translate } from '~/utils/locale'

import NumberFormat from 'react-number-format'
import { createLetterAvatar } from '~/utils/letter'
import { EditButton } from '~/components/DefaultLayout/Buttons/buttonStyle'

const DetailsMaintenanceTabs: React.FC = () => {
  const { isLoading, maintenance, setIsEdit, deleteMaintenance } =
    useShowMaintenance()

  const { Title, Text } = Typography

  if (isLoading || !maintenance) {
    return (
      <LoadingIndicator>
        <LoadingOutlined style={{ fontSize: 64, margin: 'auto' }} spin />
      </LoadingIndicator>
    )
  }

  return (
    <Card
      bordered={false}
      title={
        <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
          {translate('MaintenanceDetailsTab.MaintenanceDetails')}
        </Title>
      }
      extra={
        <Space>
          <EditButton icon={<EditOutlined />} onClick={() => setIsEdit(true)}>
            {translate('MaintenanceDetailsTab.Edit')}
          </EditButton>

          <Tooltip title={translate('HelpDeskTable.deleteTooltip')}>
            <Popconfirm
              title="Deseja realmente excluir o plano?"
              onConfirm={() => deleteMaintenance()}
            >
              <Button type="primary" danger icon={<DeleteFilled />} />
            </Popconfirm>
          </Tooltip>
        </Space>
      }
      style={{
        display: 'inline-block',
        width: '100%',
      }}
    >
      <Flex gap={20}>
        <Avatar
          shape="square"
          size={120}
          style={{
            fontSize: 30,
            color: '#fff',
            background: 'linear-gradient(135deg, #3C8ACB 0%, #3969B7 100%)',
            borderRadius: 12,
          }}
        >
          {createLetterAvatar(`${maintenance.name}`)}
        </Avatar>
        <Flex vertical gap={10} align="stretch">
          <Flex gap={60}>
            <Flex gap={10} style={{ minWidth: 400 }}>
              <Avatar
                shape="square"
                icon={
                  <TeamOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('MaintenanceDetailsTab.ClientCondominium')}
                </Title>
                {maintenance.customer?.name ? (
                  <Text style={{ fontSize: 16 }}>
                    {maintenance.customer.name}
                  </Text>
                ) : (
                  <Text style={{ fontSize: 16 }}>
                    Nenhuma informação disponível.
                  </Text>
                )}
              </div>
            </Flex>

            <Flex gap={10} style={{ minWidth: 400 }}>
              <Avatar
                shape="square"
                icon={
                  <UserOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('MaintenanceDetailsTab.ResponsibleEmployee')}
                </Title>
                {maintenance.responsible.name ? (
                  <Text style={{ fontSize: 16 }}>
                    {maintenance.responsible.name}
                  </Text>
                ) : (
                  <Text style={{ fontSize: 16 }}>
                    Nenhuma informação disponível.
                  </Text>
                )}
              </div>
            </Flex>
          </Flex>

          <Flex gap={60}>
            <Flex gap={10} style={{ minWidth: 400 }}>
              <Avatar
                shape="square"
                icon={
                  <PhoneOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('MaintenanceDetailsTab.ResponsibleEmployeePhone')}
                </Title>
                {maintenance.responsible.phone ? (
                  <Text style={{ fontSize: 16 }}>
                    <NumberFormat
                      value={maintenance.responsible.phone}
                      displayType="text"
                      format="+## (##) #####-####"
                    />
                  </Text>
                ) : (
                  <Text style={{ fontSize: 16 }}>
                    Nenhuma informação disponível.
                  </Text>
                )}
              </div>
            </Flex>

            <Flex gap={10} style={{ minWidth: 400 }}>
              <Avatar
                shape="square"
                icon={
                  <PicLeftOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('MaintenanceDetailsTab.Description')}
                </Title>
                {maintenance.description ? (
                  <Text style={{ fontSize: 16 }}>
                    {maintenance.description}
                  </Text>
                ) : (
                  <Text style={{ fontSize: 16 }}>
                    Nenhuma informação disponível.
                  </Text>
                )}
              </div>
            </Flex>
          </Flex>

          <Flex>
            <Flex gap={10} style={{ minWidth: 400 }}>
              <Avatar
                shape="square"
                icon={
                  <CalendarOutlined
                    style={{ fontSize: 12, color: '#464545' }}
                  />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  Dias futuros para criar as atividades
                </Title>
                {maintenance.future_days ? (
                  <Text style={{ fontSize: 16 }}>
                    {maintenance.future_days} dias
                  </Text>
                ) : (
                  <Text style={{ fontSize: 16 }}>
                    Nenhuma informação disponível.
                  </Text>
                )}
              </div>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  )
}

export default DetailsMaintenanceTabs
